<template>
  <div class="container mx-auto p-6">
    <div class="flex items-stretch lg:flex-row flex-col -mx-4">
      <div class="flex-1 p-4">
        <LinkCard card-title="EWD Installs" card-url="/business/ewd-installs" />
      </div>
      <div class="flex-1 p-4">
        <LinkCard card-title="Uninstall Events" card-url="/business/uninstall-events" />
      </div>
    </div>
  </div>
</template>
<script>
import LinkCard from '@/components/commons/ui/LinkCard'
export default {
  components: {
    LinkCard
  }
}
</script>